import React, { useState, useEffect } from 'react';
import { ChevronDown, MessageCircle, Loader2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { faqAPI } from '../services/api';

const FAQItem = ({ q, a }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-zinc-800 rounded-lg overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between p-4 text-left hover:bg-zinc-800/50 transition-colors"
      >
        <span className="text-white font-medium pr-4">{q}</span>
        <ChevronDown className={`h-5 w-5 text-zinc-400 flex-shrink-0 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="px-4 pb-4">
          <p className="text-zinc-400 leading-relaxed">{a}</p>
        </div>
      )}
    </div>
  );
};

const FAQPage = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFAQ = async () => {
      try {
        const res = await faqAPI.getAll();
        setFaqs(res.data);
      } catch (e) {
        setFaqs([]);
      } finally {
        setLoading(false);
      }
    };
    fetchFAQ();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
        <Loader2 className="h-8 w-8 text-amber-500 animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-zinc-950 py-12">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-white mb-4">Frequently Asked Questions</h1>
          <p className="text-zinc-400 text-lg">Everything you need to know about ordering from Forged Supps</p>
        </div>

        {faqs.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-zinc-400">No FAQs available yet.</p>
          </div>
        ) : (
          <div className="space-y-8">
            {faqs.map((section, idx) => (
              <div key={section.id || idx}>
                <h2 className="text-xl font-semibold text-amber-500 mb-4">{section.category}</h2>
                <div className="space-y-2">
                  {section.items.map((item, i) => (
                    <FAQItem key={i} q={item.question} a={item.answer} />
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="mt-12 bg-zinc-900 rounded-xl border border-zinc-800 p-8 text-center">
          <h3 className="text-xl font-semibold text-white mb-2">Still have questions?</h3>
          <p className="text-zinc-400 mb-6">Our team is happy to help via WhatsApp</p>
          <a href="https://wa.me/447440352811" target="_blank" rel="noopener noreferrer">
            <Button className="bg-green-600 hover:bg-green-700 text-white font-semibold h-12 px-8">
              <MessageCircle className="h-5 w-5 mr-2" />
              Chat on WhatsApp
            </Button>
          </a>
        </div>

        <div className="mt-8 text-center">
          <Link to="/terms" className="text-amber-500 hover:underline text-sm">
            Read our full Terms & Disclaimer →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;
